import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { DashboardCardComponent } from './dashboard-card.component';
import { DashboardComponent } from './dashboard.component';
import { PrecoAlertaCardComponent } from './preco-alerta-card.component';

const routes: Routes = [
  { path: '', component: DashboardComponent },
];

/**
 * Feature lazy-loaded em `app-routing` (`path: 'dashboard-frota'`). Rota filha
 * vazia para o componente raiz do módulo.
 */
@NgModule({
  declarations: [
    DashboardComponent,
    DashboardCardComponent,
    PrecoAlertaCardComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgxPaginationModule,
    RouterModule.forChild(routes),
  ],
  exports: [DashboardCardComponent, PrecoAlertaCardComponent],
})
export class DashboardModule {}
